export const bookingService = {
  getUpcomingBooking: (data) => window.axios.post("get-upcoming-booking", data),
  getCompletedBooking: (data) =>
    window.axios.post("get-completed-booking", data),
  getCancelBooking: (data) => window.axios.post("get-cancel-booking", data),
  getUpcomingBookingOnOff: (data) =>
    window.axios.post("update-upcoming-booking-status", data),
  getMyBooking: (data) => window.axios.post("my-bookings", data),
  getBooking: (data) => window.axios.post("get-booking-info", data),
};
